module.exports = __webpack_public_path__ + "static/media/ONGC.a362ffef.txt";